import { Component } from '@angular/core';
import { HybridToolsService } from '../../services/hybrid-tools.service';

@Component({
    selector: 'cat-footer',
    templateUrl: './footer.component.html',
})
export class FooterComponent {
    constructor(public hybridToolsService: HybridToolsService) {}
}
